var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc40SocialTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M25.973 4c.528 4.541 3.062 7.248 7.469 7.536v5.108c-2.554.25-4.79-.586-7.393-2.16v9.552c0 12.135-13.229 15.927-18.547 7.229-3.418-5.597-1.325-15.418 9.638-15.812v5.386c-.835.134-1.728.346-2.544.624-2.438.826-3.82 2.371-3.437 5.098.74 5.222 10.32 6.768 9.524-3.437V4.01h5.29V4Z",
  clipRule: "evenodd"
})));
export default SvgIc40SocialTiktok;